import MDBox from "components/MDBox";
import Switch from "@mui/material/Switch";
import {
  useMaterialUIController,
  setDarkMode
} from "context";
import Icon from "@mui/material/Icon";

function ThemeController() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    darkMode,
  } = controller;
  const handleDarkMode = () => setDarkMode(dispatch, !darkMode);
  return (
    <MDBox pr={2.5} pt={0.2}display="flex" justifyContent="flex-end" alignItems="center" gap={1} lineHeight={1} backgroundColor="black">
      <Icon style={{color:"white"}} fontSize="small" >light_mode</Icon>
        <Switch checked={darkMode} onChange={handleDarkMode}/>
      <Icon style={{color:"white"}} fontSize="small">dark_mode</Icon>
    </MDBox>
  );
}

export default ThemeController;
